import {Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-ui-block',
  templateUrl: './ui-block.component.html',
  imports: [
    TranslatePipe,
  ],
  styleUrls: ['./ui-block.component.scss']
})
export class UiBlockComponent { // TODO: Use this in nouveautes modal form.
  public readonly isOptional = input<boolean>(false);
  public readonly addSectionLabel = input<string>('');

  public readonly title = input.required<string>();

  public readonly onSectionAdd = output<PointerEvent>();
}
